import { queryOptions } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { Member } from '@/api/generated/types'

export const listTeamMembers = (teamUuid: string, signal?: AbortSignal) =>
  api.get<Member[]>(`/teams/${teamUuid}/members`, { signal }).then((r) => r.data)

export const teamMemberQueries = {
  all: ['teams', 'members'] as const,
  list: (teamUuid: string) =>
    queryOptions({
      queryKey: [...teamMemberQueries.all, teamUuid],
      queryFn: ({ signal }) => listTeamMembers(teamUuid, signal),
    }),
}
